export const enhanceLinks = (html) => {
  if (!html) return html
  const container = document.createElement('div')
  container.innerHTML = html

  const urlRegex = /(https?:\/\/[^\s<>"]+)/g
  const linkifyTextNodes = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue
      urlRegex.lastIndex = 0
      if (!urlRegex.test(text)) return
      urlRegex.lastIndex = 0
      const frag = document.createDocumentFragment()
      let lastIndex = 0
      let match
      while ((match = urlRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.substring(lastIndex, match.index)))
        }
        const a = document.createElement('a')
        a.href = match[0]
        a.target = '_blank'
        a.rel = 'noopener noreferrer'
        a.textContent = match[0]
        frag.appendChild(a)
        lastIndex = match.index + match[0].length
      }
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.substring(lastIndex)))
      }
      node.parentNode.replaceChild(frag, node)
    } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'A') {
      Array.from(node.childNodes).forEach(linkifyTextNodes)
    }
  }
  Array.from(container.childNodes).forEach(linkifyTextNodes)

  container.querySelectorAll('a').forEach(a => {
    a.setAttribute('target', '_blank')
    a.setAttribute('rel', 'noopener noreferrer')
  })

  return container.innerHTML
}
